import { CallApi } from '@signavio/kraken'
import { schema as schemas } from 'normalizr'
import queryString from 'qs'

import { ADMIN_API_BASE } from '../../callApi'

export const collection = 'adminEvents'

export const schema = new schemas.Array(new schemas.Entity(collection))

export const fetch = (callApi: CallApi) => (options: object) =>
  callApi(`${ADMIN_API_BASE}/events?${queryString.stringify(options)}`, schema)
